import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import Pagination from "../../common/Pagination";
import * as actions from "../redux/VipListAction";

export const VipDownline = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { memberid, username } = useParams();

  const [swalProps, setSwalProps] = useState({});
  const [grouppagenum, setGrouppagenum] = useState(0);
  const [memberpagenum, setMemberpagenum] = useState(0);
  const [downline, setDownline] = useState([{ memberid, username }]);
  const [memberId, setMemberid] = useState(memberid);

  const vipListState = useSelector(({ vipList }) => vipList, shallowEqual);

  useEffect(() => {
    fetchVipReport();
  }, [memberId]);

  const fetchVipReport = (grouppage, memberpage) => {
    setGrouppagenum(grouppage ?? 0);
    setMemberpagenum(memberpage ?? 0);
    dispatch(
      actions.fetchVipDownline({
        action: "vipmemberdownlinelist",
        memberid: memberId,
        grouppagenum: grouppage ?? 0,
        memberpagenum: memberpage ?? 0,
      })
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i
          className="bi bi-chevron-left fs-2 mb-1"
          onClick={() => window.history.back()}
        />
        <h2>{intl.formatMessage({ id: "vipDownline" })}</h2>
      </div>
      <div>
        <nav>
          <ol className="breadcrumb">
            {downline.length > 0 &&
              downline.map((member, index) => (
                <li key={index}>
                  {downline.length > 1 && index - (downline.length - 2) > 0 && (
                    <span className="d-inline-block px-1">/</span>
                  )}
                  <span
                    onClick={() => {
                      setMemberid(member.memberid);
                      setDownline((prev) => prev.slice(0, index + 1));
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {member.username}
                    </span>
                  </span>
                </li>
              ))}
          </ol>
        </nav>
      </div>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div
        className="p-3 rounded"
        style={{ backgroundColor: "var(--table-background)" }}
      >
        <div className="table-responsive">
          <table className="custom-table">
            <thead>
              <tr>
                <th>{intl.formatMessage({ id: "no" })}</th>
                <th>{intl.formatMessage({ id: "username" })}</th>
                <th>{intl.formatMessage({ id: "memberCount" })}</th>
              </tr>
            </thead>
            <tbody>
              {vipListState.vipDownline?.vippDownlineList ? (
                vipListState.vipDownline.vippDownlineList.vippDownlineLists
                  .length > 0 ? (
                  vipListState.vipDownline.vippDownlineList.vippDownlineLists.map(
                    (memberVipReport, index) => (
                      <tr key={index}>
                        <td>{grouppagenum * 10 + index + 1}</td>
                        <td>
                          <span
                            className="text-primary text-underline"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setMemberid(memberVipReport.memberid);
                              setDownline((prev) => [
                                ...prev,
                                {
                                  memberid: memberVipReport.memberid,
                                  username: memberVipReport.username,
                                },
                              ]);
                            }}
                          >
                            {memberVipReport.username}
                          </span>
                        </td>
                        <td>{memberVipReport.membercount}</td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPages={parseInt(
            vipListState.vipDownline?.vippDownlineList?.totalpage ?? "0"
          )}
          currentPage={grouppagenum}
          onPageChange={(pageNumber) => {
            fetchVipReport(pageNumber, memberpagenum);
          }}
        />
      </div>
      <div className="mt-4 mb-2 fs-5">
        {intl.formatMessage({ id: "memberList" })}
      </div>
      <div
        className="mb-4 rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow"
        style={{ border: "1px solid grey" }}
      >
        <table className="text-start table-report w-100">
          <tbody>
            <tr>
              <td className="col-3 ps-2">
                {intl.formatMessage({ id: "member" })} :{" "}
                {vipListState.vipDownline?.vipMemberDownlineList.totalmember}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className="p-3 rounded"
        style={{ backgroundColor: "var(--table-background)" }}
      >
        <div className="table-responsive">
          <table className="custom-table">
            <thead>
              <tr>
                <th>{intl.formatMessage({ id: "no" })}</th>
                <th>{intl.formatMessage({ id: "username" })}</th>
                <th>{intl.formatMessage({ id: "date" })}</th>
              </tr>
            </thead>
            <tbody>
              {vipListState.vipDownline?.vipMemberDownlineList ? (
                vipListState.vipDownline.vipMemberDownlineList
                  .vipMemberDownlineLists.length > 0 ? (
                  vipListState.vipDownline.vipMemberDownlineList.vipMemberDownlineLists.map(
                    (memberVipReport, index) => (
                      <tr key={index}>
                        <td>{memberpagenum * 10 + index + 1}</td>
                        <td>{memberVipReport.username}</td>
                        <td>{memberVipReport.registerdate}</td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPages={parseInt(
            vipListState.vipDownline?.vipMemberDownlineList.totalpage ?? "0"
          )}
          currentPage={memberpagenum}
          onPageChange={(pageNumber) => {
            fetchVipReport(grouppagenum, pageNumber);
          }}
        />
      </div>
    </div>
  );
};
